import _slicedToArray from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _assertThisInitialized from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _createClass from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _regeneratorRuntime from "/home/runner/work/react/react/docs/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var _RelativeTimeElement_instances, _RelativeTimeElement_customTitle, _RelativeTimeElement_updating, _RelativeTimeElement_lang_get, _RelativeTimeElement_renderRoot, _RelativeTimeElement_getFormattedTitle, _RelativeTimeElement_resolveFormat, _RelativeTimeElement_getDurationFormat, _RelativeTimeElement_getRelativeFormat, _RelativeTimeElement_getDateTimeFormat, _RelativeTimeElement_onRelativeTimeUpdated;

import { Duration, elapsedTime, getRelativeTimeUnit, isDuration, roundToSingleUnit, unitNames } from './duration.js';
var root = typeof globalThis !== 'undefined' ? globalThis : window;
var HTMLElement = root.HTMLElement || null;
var emptyDuration = new Duration();
var microEmptyDuration = new Duration(0, 0, 0, 0, 0, 1);
export var RelativeTimeUpdatedEvent = /*#__PURE__*/function (_Event) {
  _inherits(RelativeTimeUpdatedEvent, _Event);

  var _super = _createSuper(RelativeTimeUpdatedEvent);

  function RelativeTimeUpdatedEvent(oldText, newText, oldTitle, newTitle) {
    var _this;

    _classCallCheck(this, RelativeTimeUpdatedEvent);

    _this = _super.call(this, 'relative-time-updated', {
      bubbles: true,
      composed: true
    });
    _this.oldText = oldText;
    _this.newText = newText;
    _this.oldTitle = oldTitle;
    _this.newTitle = newTitle;
    return _this;
  }

  return RelativeTimeUpdatedEvent;
}( /*#__PURE__*/_wrapNativeSuper(Event));

function getUnitFactor(el) {
  if (!el.date) return Infinity;

  if (el.format === 'duration' || el.format === 'elapsed') {
    var precision = el.precision;

    if (precision === 'second') {
      return 1000;
    } else if (precision === 'minute') {
      return 60 * 1000;
    }
  }

  var ms = Math.abs(Date.now() - el.date.getTime());
  if (ms < 60 * 1000) return 1000;
  if (ms < 60 * 60 * 1000) return 60 * 1000;
  return 60 * 60 * 1000;
}

var dateObserver = new ( /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);

    this.elements = new Set();
    this.time = Infinity;
    this.timer = -1;
  }

  _createClass(_class, [{
    key: "observe",
    value: function observe(element) {
      var _this2 = this;

      if (this.elements.has(element)) return;
      this.elements.add(element);
      var date = element.date;

      if (date && date.getTime()) {
        var ms = getUnitFactor(element);
        var time = Date.now() + ms;

        if (time < this.time) {
          clearTimeout(this.timer);
          this.timer = setTimeout(function () {
            return _this2.update();
          }, ms);
          this.time = time;
        }
      }
    }
  }, {
    key: "unobserve",
    value: function unobserve(element) {
      if (!this.elements.has(element)) return;
      this.elements.delete(element);
    }
  }, {
    key: "update",
    value: function update() {
      var _this3 = this;

      clearTimeout(this.timer);
      if (!this.elements.size) return;
      var nearestDistance = Infinity;

      var _iterator = _createForOfIteratorHelper(this.elements),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var timeEl = _step.value;
          nearestDistance = Math.min(nearestDistance, getUnitFactor(timeEl));
          timeEl.update();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.time = Math.min(60 * 60 * 1000, nearestDistance);
      this.timer = setTimeout(function () {
        return _this3.update();
      }, this.time);
      this.time += Date.now();
    }
  }]);

  return _class;
}())();

var RelativeTimeElement = /*#__PURE__*/function (_HTMLElement) {
  _inherits(RelativeTimeElement, _HTMLElement);

  var _super2 = _createSuper(RelativeTimeElement);

  function RelativeTimeElement() {
    var _this4;

    _classCallCheck(this, RelativeTimeElement);

    _this4 = _super2.apply(this, arguments);

    _RelativeTimeElement_instances.add(_assertThisInitialized(_this4));

    _RelativeTimeElement_customTitle.set(_assertThisInitialized(_this4), false);

    _RelativeTimeElement_updating.set(_assertThisInitialized(_this4), false);

    _RelativeTimeElement_renderRoot.set(_assertThisInitialized(_this4), _this4.shadowRoot ? _this4.shadowRoot : _this4.attachShadow ? _this4.attachShadow({
      mode: 'open'
    }) : _assertThisInitialized(_this4));

    _RelativeTimeElement_onRelativeTimeUpdated.set(_assertThisInitialized(_this4), null);

    return _this4;
  }

  _createClass(RelativeTimeElement, [{
    key: "onRelativeTimeUpdated",
    get: function get() {
      return __classPrivateFieldGet(this, _RelativeTimeElement_onRelativeTimeUpdated, "f");
    },
    set: function set(listener) {
      if (__classPrivateFieldGet(this, _RelativeTimeElement_onRelativeTimeUpdated, "f")) {
        this.removeEventListener('relative-time-updated', __classPrivateFieldGet(this, _RelativeTimeElement_onRelativeTimeUpdated, "f"));
      }

      __classPrivateFieldSet(this, _RelativeTimeElement_onRelativeTimeUpdated, typeof listener === 'object' || typeof listener === 'function' ? listener : null, "f");

      if (typeof listener === 'function') {
        this.addEventListener('relative-time-updated', listener);
      }
    }
  }, {
    key: "second",
    get: function get() {
      var second = this.getAttribute('second');
      if (second === 'numeric' || second === '2-digit') return second;
    },
    set: function set(value) {
      this.setAttribute('second', value || '');
    }
  }, {
    key: "minute",
    get: function get() {
      var minute = this.getAttribute('minute');
      if (minute === 'numeric' || minute === '2-digit') return minute;
    },
    set: function set(value) {
      this.setAttribute('minute', value || '');
    }
  }, {
    key: "hour",
    get: function get() {
      var hour = this.getAttribute('hour');
      if (hour === 'numeric' || hour === '2-digit') return hour;
    },
    set: function set(value) {
      this.setAttribute('hour', value || '');
    }
  }, {
    key: "weekday",
    get: function get() {
      var weekday = this.getAttribute('weekday');

      if (weekday === 'long' || weekday === 'short' || weekday === 'narrow') {
        return weekday;
      }

      if (this.format === 'datetime' && weekday !== '') return this.formatStyle;
    },
    set: function set(value) {
      this.setAttribute('weekday', value || '');
    }
  }, {
    key: "day",
    get: function get() {
      var _a;

      var day = (_a = this.getAttribute('day')) !== null && _a !== void 0 ? _a : 'numeric';
      if (day === 'numeric' || day === '2-digit') return day;
    },
    set: function set(value) {
      this.setAttribute('day', value || '');
    }
  }, {
    key: "month",
    get: function get() {
      var format = this.format;
      var month = this.getAttribute('month');
      if (month === '') return;
      month !== null && month !== void 0 ? month : month = format === 'datetime' ? this.formatStyle : 'short';

      if (month === 'numeric' || month === '2-digit' || month === 'short' || month === 'long' || month === 'narrow') {
        return month;
      }
    },
    set: function set(value) {
      this.setAttribute('month', value || '');
    }
  }, {
    key: "year",
    get: function get() {
      var _a;

      var year = this.getAttribute('year');
      if (year === 'numeric' || year === '2-digit') return year;

      if (!this.hasAttribute('year') && new Date().getUTCFullYear() !== ((_a = this.date) === null || _a === void 0 ? void 0 : _a.getUTCFullYear())) {
        return 'numeric';
      }
    },
    set: function set(value) {
      this.setAttribute('year', value || '');
    }
  }, {
    key: "timeZoneName",
    get: function get() {
      var name = this.getAttribute('time-zone-name');

      if (name === 'long' || name === 'short' || name === 'shortOffset' || name === 'longOffset' || name === 'shortGeneric' || name === 'longGeneric') {
        return name;
      }
    },
    set: function set(value) {
      this.setAttribute('time-zone-name', value || '');
    }
  }, {
    key: "prefix",
    get: function get() {
      var _a;

      return (_a = this.getAttribute('prefix')) !== null && _a !== void 0 ? _a : this.format === 'datetime' ? '' : 'on';
    },
    set: function set(value) {
      this.setAttribute('prefix', value);
    }
  }, {
    key: "threshold",
    get: function get() {
      var threshold = this.getAttribute('threshold');
      return threshold && isDuration(threshold) ? threshold : 'P30D';
    },
    set: function set(value) {
      this.setAttribute('threshold', value);
    }
  }, {
    key: "tense",
    get: function get() {
      var tense = this.getAttribute('tense');
      if (tense === 'past') return 'past';
      if (tense === 'future') return 'future';
      return 'auto';
    },
    set: function set(value) {
      this.setAttribute('tense', value);
    }
  }, {
    key: "precision",
    get: function get() {
      var precision = this.getAttribute('precision');
      if (unitNames.includes(precision)) return precision;
      if (this.format === 'micro') return 'minute';
      return 'second';
    },
    set: function set(value) {
      this.setAttribute('precision', value);
    }
  }, {
    key: "format",
    get: function get() {
      var format = this.getAttribute('format');
      if (format === 'datetime') return 'datetime';
      if (format === 'relative') return 'relative';
      if (format === 'duration') return 'duration';
      if (format === 'micro') return 'micro';
      if (format === 'elapsed') return 'elapsed';
      return 'auto';
    },
    set: function set(value) {
      this.setAttribute('format', value);
    }
  }, {
    key: "formatStyle",
    get: function get() {
      var formatStyle = this.getAttribute('format-style');
      if (formatStyle === 'long') return 'long';
      if (formatStyle === 'short') return 'short';
      if (formatStyle === 'narrow') return 'narrow';
      var format = this.format;
      if (format === 'elapsed' || format === 'micro') return 'narrow';
      if (format === 'datetime') return 'short';
      return 'long';
    },
    set: function set(value) {
      this.setAttribute('format-style', value);
    }
  }, {
    key: "datetime",
    get: function get() {
      return this.getAttribute('datetime') || '';
    },
    set: function set(value) {
      this.setAttribute('datetime', value);
    }
  }, {
    key: "date",
    get: function get() {
      var parsed = Date.parse(this.datetime);
      return Number.isNaN(parsed) ? null : new Date(parsed);
    },
    set: function set(value) {
      this.datetime = (value === null || value === void 0 ? void 0 : value.toISOString()) || '';
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.update();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      dateObserver.unobserve(this);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      var _this5 = this;

      if (oldValue === newValue) return;

      if (attrName === 'title') {
        __classPrivateFieldSet(this, _RelativeTimeElement_customTitle, newValue !== null && (this.date && __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_getFormattedTitle).call(this, this.date)) !== newValue, "f");
      }

      if (!__classPrivateFieldGet(this, _RelativeTimeElement_updating, "f") && !(attrName === 'title' && __classPrivateFieldGet(this, _RelativeTimeElement_customTitle, "f"))) {
        __classPrivateFieldSet(this, _RelativeTimeElement_updating, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return Promise.resolve();

                case 2:
                  _this5.update();

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))(), "f");
      }
    }
  }, {
    key: "update",
    value: function update() {
      var oldText = __classPrivateFieldGet(this, _RelativeTimeElement_renderRoot, "f").textContent || this.textContent || '';
      var oldTitle = this.getAttribute('title') || '';
      var newTitle = oldTitle;
      var date = this.date;

      if (typeof Intl === 'undefined' || !Intl.DateTimeFormat || !date) {
        __classPrivateFieldGet(this, _RelativeTimeElement_renderRoot, "f").textContent = oldText;
        return;
      }

      var now = Date.now();

      if (!__classPrivateFieldGet(this, _RelativeTimeElement_customTitle, "f")) {
        newTitle = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_getFormattedTitle).call(this, date) || '';
        if (newTitle) this.setAttribute('title', newTitle);
      }

      var duration = elapsedTime(date, this.precision, now);

      var format = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_resolveFormat).call(this, duration);

      var newText = oldText;

      if (format === 'duration') {
        newText = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_getDurationFormat).call(this, duration);
      } else if (format === 'relative') {
        newText = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_getRelativeFormat).call(this, duration);
      } else {
        newText = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "m", _RelativeTimeElement_getDateTimeFormat).call(this, date);
      }

      if (newText) {
        __classPrivateFieldGet(this, _RelativeTimeElement_renderRoot, "f").textContent = newText;
      } else if (this.shadowRoot === __classPrivateFieldGet(this, _RelativeTimeElement_renderRoot, "f") && this.textContent) {
        __classPrivateFieldGet(this, _RelativeTimeElement_renderRoot, "f").textContent = this.textContent;
      }

      if (newText !== oldText || newTitle !== oldTitle) {
        this.dispatchEvent(new RelativeTimeUpdatedEvent(oldText, newText, oldTitle, newTitle));
      }

      if (format === 'relative' || format === 'duration') {
        dateObserver.observe(this);
      } else {
        dateObserver.unobserve(this);
      }

      __classPrivateFieldSet(this, _RelativeTimeElement_updating, false, "f");
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ['second', 'minute', 'hour', 'weekday', 'day', 'month', 'year', 'time-zone-name', 'prefix', 'threshold', 'tense', 'precision', 'format', 'format-style', 'datetime', 'lang', 'title'];
    }
  }]);

  return RelativeTimeElement;
}(HTMLElement);

export { RelativeTimeElement as default };
_RelativeTimeElement_customTitle = new WeakMap(), _RelativeTimeElement_updating = new WeakMap(), _RelativeTimeElement_renderRoot = new WeakMap(), _RelativeTimeElement_onRelativeTimeUpdated = new WeakMap(), _RelativeTimeElement_instances = new WeakSet(), _RelativeTimeElement_lang_get = function _RelativeTimeElement_lang_get() {
  var _a;

  return ((_a = this.closest('[lang]')) === null || _a === void 0 ? void 0 : _a.getAttribute('lang')) || this.ownerDocument.documentElement.getAttribute('lang') || 'default';
}, _RelativeTimeElement_getFormattedTitle = function _RelativeTimeElement_getFormattedTitle(date) {
  return new Intl.DateTimeFormat(__classPrivateFieldGet(this, _RelativeTimeElement_instances, "a", _RelativeTimeElement_lang_get), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short'
  }).format(date);
}, _RelativeTimeElement_resolveFormat = function _RelativeTimeElement_resolveFormat(duration) {
  var format = this.format;
  if (format === 'datetime') return 'datetime';
  if (format === 'duration') return 'duration';
  if (format === 'elapsed') return 'duration';
  if (format === 'micro') return 'duration';

  if ((format === 'auto' || format === 'relative') && typeof Intl !== 'undefined' && Intl.RelativeTimeFormat) {
    var tense = this.tense;
    if (tense === 'past' || tense === 'future') return 'relative';
    if (Duration.compare(duration, this.threshold) === 1) return 'relative';
  }

  return 'datetime';
}, _RelativeTimeElement_getDurationFormat = function _RelativeTimeElement_getDurationFormat(duration) {
  var locale = __classPrivateFieldGet(this, _RelativeTimeElement_instances, "a", _RelativeTimeElement_lang_get);

  var format = this.format;
  var style = this.formatStyle;
  var tense = this.tense;
  var empty = emptyDuration;

  if (format === 'micro') {
    duration = roundToSingleUnit(duration);
    empty = microEmptyDuration;

    if (this.tense === 'past' && duration.sign !== -1 || this.tense === 'future' && duration.sign !== 1) {
      duration = microEmptyDuration;
    }
  } else if (tense === 'past' && duration.sign !== -1 || tense === 'future' && duration.sign !== 1) {
    duration = empty;
  }

  var display = "".concat(this.precision, "sDisplay");

  if (duration.blank) {
    return empty.toLocaleString(locale, _defineProperty({
      style: style
    }, display, 'always'));
  }

  return duration.abs().toLocaleString(locale, {
    style: style
  });
}, _RelativeTimeElement_getRelativeFormat = function _RelativeTimeElement_getRelativeFormat(duration) {
  var relativeFormat = new Intl.RelativeTimeFormat(__classPrivateFieldGet(this, _RelativeTimeElement_instances, "a", _RelativeTimeElement_lang_get), {
    numeric: 'auto',
    style: this.formatStyle
  });
  var tense = this.tense;
  if (tense === 'future' && duration.sign !== 1) duration = emptyDuration;
  if (tense === 'past' && duration.sign !== -1) duration = emptyDuration;

  var _getRelativeTimeUnit = getRelativeTimeUnit(duration),
      _getRelativeTimeUnit2 = _slicedToArray(_getRelativeTimeUnit, 2),
      int = _getRelativeTimeUnit2[0],
      unit = _getRelativeTimeUnit2[1];

  if (unit === 'second' && int < 10) {
    return relativeFormat.format(0, 'second');
  }

  return relativeFormat.format(int, unit);
}, _RelativeTimeElement_getDateTimeFormat = function _RelativeTimeElement_getDateTimeFormat(date) {
  var formatter = new Intl.DateTimeFormat(__classPrivateFieldGet(this, _RelativeTimeElement_instances, "a", _RelativeTimeElement_lang_get), {
    second: this.second,
    minute: this.minute,
    hour: this.hour,
    weekday: this.weekday,
    day: this.day,
    month: this.month,
    year: this.year,
    timeZoneName: this.timeZoneName
  });
  return "".concat(this.prefix, " ").concat(formatter.format(date)).trim();
};